import React from "react";
import { useEffect, useState } from "react";

import "./card.css";
import Button from "@mui/material/Button";
import { FormLabel, Box, Grid, backdropClasses, Card, CardMedia, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import Checkbox from "@mui/material/Checkbox";
import { GetTimeString } from "../../utiles";
import { useNavigate } from "react-router-dom";

export interface URIProp {
  asset_id: any;
  level: any;
  name: string;
  img_url: string;
  onClick?: any;
  isSelected?: any;
  schema?: string;
}

const InventoryItemCard = ({
  asset_id,
  level,
  name,
  img_url,
  onClick,
  isSelected,
  schema
}: URIProp) => {
  const navigate = useNavigate();


  const [backAmount, setBackamount] = useState("");
  const [hide, setHide] = useState(false);
  let result: any;
  const btnStyle = {
    width: "100%",
    minWidth: "2px",
    color: "white",
    height: "100%",
    fontWeight: "bold",
    borderColor: "#d3b69a",
    borderRadius: "15px",
    fontSize: "10px",
    padding: "16px",
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const box_style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    margin: "auto",
    height: "100%",
    maxWidth: "200px",
    width: "90%",
    bgcolor: "#1a1f3c",
    borderRadius: 2,
    border: "1px solid " + (isSelected ? "#1fff57" : "black"),
    backgroundImage: "radial-gradient(circle, #5c0067 0%, #06313a 100%)",
    cursor: "pointer",
  };

  const display_none = {
    display: "none",
  };

  const modal_style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#1a203c",
    color: "white",
    border: "4px solid #000",
    boxShadow: 24,
    borderColor: "#ea923e",
    textAlign: "center",
    borderRadius: "16px",
    p: 4,
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const showNFTDetail = (id: any) => {
    if (onClick) onClick(id);
    else navigate("/detail/" + id);
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
      <Card
        className="nft-card"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => {
          showNFTDetail(asset_id);
        }}
        sx={{
          background: 'linear-gradient(135deg, #7d5014 0%, #5c3c10 100%)',
          border: isSelected ? '4px solid #1fff57' : '3px solid #5c3c10',
          borderRadius: '12px',
          position: 'relative',
          overflow: 'hidden',
          cursor: "pointer",
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          '&:hover': {
            borderColor: '#d9534f',
            transform: 'translateY(-5px)',
            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.4)'
          },
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)'
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 0
        }} />

        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 2,
            bgcolor: 'rgba(0,0,0,0.7)',
            borderRadius: '50%',
            width: 28,
            height: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid #d9a758',
            boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          <Typography variant="subtitle2" sx={{ color: '#d9a758', fontWeight: 'bold' }}>
            {level || 1}
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1,
            minHeight: 80,
            m: 0,
            p: 0,
            zIndex: 1,
          }}
        >
          <CardMedia
            component="img"
            image={img_url}
            alt={name}
            sx={{
              width: '100%',
              height: '100%',
              aspectRatio: '1/1',
              objectFit: 'contain',
              transition: 'transform 0.3s ease',
              transform: isHovered ? 'scale(1.05)' : 'scale(1)',
              position: 'relative',
              zIndex: 1,
              m: 0, // Remove margin
              p: 0, // Remove padding
              display: 'block',
            }}
          />
        </Box>
        <CardContent
          sx={{
            flexGrow: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            bgcolor: 'rgba(0,0,0,0.6)',
            borderTop: '2px solid #5c3c10',
            position: 'relative',
            zIndex: 1
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              gap: 0.5,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: 'white',
                fontWeight: 600,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                fontSize: { xs: '0.95rem', sm: '1rem' }
              }}
            >
              {name}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: '#d9a758',
                fontWeight: 500,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                fontSize: '0.8rem',
                letterSpacing: 0.5,
              }}
            >
              #{asset_id}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: '#b0b0b0',
                fontWeight: 400,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                fontSize: '0.7rem'
              }}
            >
              {schema}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default InventoryItemCard;



// <Grid xl={2} md={2} sm={3} xs={3} sx={{ mb: 3 }}>
// <Box
//   sx={box_style}
//   onClick={() => {
//     showNFTDetail(asset_id);
//   }}
// >
/* <div>
  <Modal
    open={open}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box sx={modal_style}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Type stake amounts
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 5 }}>
        <TextField
          style={{ color: "white" }}
          id="outlined-number"
          label="Number"
          type="number"
          value={backAmount}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={() => {}}
        />
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        <Button variant="outlined" sx={{ mr: 2 }} onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained">Confirm</Button>
      </Typography>
    </Box>
  </Modal>
</div> *

// <Box sx={{ display: "flex", alignItems: "center" }}>
  {/* <Typography
    className="name"
    variant="h6"
    sx={{
      fontSize: { xs: "12px", sm: "12px", md: "20px" },
      color: "white",
      padding: "8px",
      flexGrow: 1,
    }}
    component="p"
  >
    Level : {level}
  </Typography> 
// </Box>
{/* <Box style={{ width: "100%", margin: "auto" }}>
  <Box sx={{ width: "90%", textAlign: "center", margin: "auto" }}>
    <img
      style={{ width: "100%", borderRadius: "4px" }}
      src={img_url}
      alt="card"
    />
  </Box>
</Box> 
// <Box style={{ width: "100%", margin: "auto", marginBottom: "0px" }}>
  {/* <Box>
    <Typography
      className="name"
      variant="h6"
      sx={{
        fontSize: { xs: "12px", sm: "12px", md: "20px" },
        width: "90%",
        margin: "auto",
        color: "white",
        flexGrow: 1,
      }}
      component="p"
    >
      {name}
    </Typography>
  </Box> */
// <Grid
//   container
//   style={{
//     justifyContent: "space-between",
//     width: "90%",
//     margin: "auto",
//     marginTop: "5px",
//   }}
// >
// <Grid item xs={12}>
//   <Box
//     sx={{
//       bgcolor: "#ea923e",
//       fontWeight: "bold",
//       boxShadow: 1,
//       borderRadius: 3,
//       width: "100%",
//       height: "70%",
//     }}
//   >
{/* <Button sx={btnStyle} onClick={() => { }}>Exploration</Button> */ }
//   </Box>
// </Grid>
//     </Gri>
//   </Box>
// </Box>
// </Grid>